import { Button, ButtonProps } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from '@tanstack/react-router';
import { useAuthContext } from '@/context/auth/useAuthContext';
import { text } from '@/theme/colors/palettes';

const WeeklyReportDashboardButton = ({
  accountMismatch = false,
  children,
  ...props
}: ButtonProps & { accountMismatch?: boolean }) => {
  const { isPeerSupport } = useAuthContext();

  return (
    <Button
      as={RouterLink}
      to={isPeerSupport ? '/organization/dashboard/peer-support' : '/user/dashboard'}
      variant="ghost"
      bg="transparent"
      color={text.mediumBlue}
      fontSize="16px"
      fontWeight={700}
      boxShadow="none"
      leftIcon={<ArrowBackIcon boxSize="16px" stroke="currentColor" strokeWidth={1.5} />}
      iconSpacing={3}
      _hover={{ bg: 'transparent', opacity: 0.8 }}
      _active={{ bg: 'transparent' }}
      h="54px"
      px={2}
      whiteSpace="normal"
      maxW="100%"
      {...props}
    >
      {children ?? (accountMismatch ? 'Take me back to Dashboard' : 'Cancel, Take me to Dashboard')}
    </Button>
  );
};

export default WeeklyReportDashboardButton;
